import axiosClient from "./AxiosClient";

// One completed frontend chat turn, reported to the backend so it can be logged
// into the separate frontend Langfuse project. Fire-and-forget: never throws.
export interface FrontendObservabilityPayload {
  session_id: string | null;
  agent_id: number;
  agent_identifier: string;
  agent_name: string;
  endpoint: string;
  input: string;
  output?: string;
  status: "success" | "error";
  error?: string;
  request_id?: string;
  started_at: string; // ISO timestamp
  ended_at: string; // ISO timestamp
  metadata?: Record<string, unknown>;
}

export const recordFrontendObservability = (
  payload: FrontendObservabilityPayload
): void => {
  axiosClient.post("/frontend-observability", payload).catch((err) => {
    console.warn("[Observability] failed to record frontend turn", err);
  });
};
